module.exports = __webpack_public_path__ + "static/autobiography-of-benjamin-franklin-264262d6ec0938d723c1c2893d5f1318.jpg";